import React, { ReactElement } from 'react';

interface Props {
  width?: number | string;
  height?: number | string;
  style?: React.CSSProperties;
}

const Studio = (props: Props): ReactElement => {
  const { width, height, style } = props;
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      style={style}
      viewBox="0 0 36 36"
    >
      <g fill="none" fillRule="evenodd">
        <g
          fill="currentColor"
          transform="translate(-611 -464) translate(365 357) translate(192 67) translate(48 34)"
        >
          <path d="M40 32.909l-8.656 6.88-9.388-2.87H22V25.989H12v7.887l-4-1.223V15.348L31.344 8.21 40 15.091V32.91zM20 36.32l-6-1.834v-6.512h6v8.346zM31.768 6L6 13.881v20.238L31.768 42 42 33.863V14.137L31.768 6z" />
        </g>
      </g>
    </svg>
  );
};

Studio.defaultProps = {
  width: '36px',
  height: '36px',
};

export default Studio;
